module.exports = __webpack_public_path__ + "img/thumb_03.75c226ad.jpg";